/**
 * The source of the editor.
 *
 * Are we:
 * - Replying to another component?
 * - Adding an standalone comment directly to an item?
 * - etc...
 */ export var CommentEditorSource = /*#__PURE__*/ function(CommentEditorSource) {
    /** The user intends to post a comment at the root level of an item. */ CommentEditorSource["Independent"] = "independent";
    /** The user intends to reply to a comment that already exists. */ CommentEditorSource["Reply"] = "reply";
    /** The user is editing an existing comment. */ CommentEditorSource["Edit"] = "edit";
    return CommentEditorSource;
}({});
export var RequestError = /*#__PURE__*/ function(RequestError) {
    RequestError[RequestError["GeneralError"] = 0] = "GeneralError";
    return RequestError;
}({});

//# sourceMappingURL=types.js.map